module.exports = __webpack_public_path__ + "img/7.eec6563c.svg";